// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  figure: "SectionBeliefs__figure",
  figureInner: "SectionBeliefs__figureInner",
  head: "SectionBeliefs__head",
  headBlock: "SectionBeliefs__headBlock",
  paper: "SectionBeliefs__paper",
  section: "SectionBeliefs__section",
  standfirst: "SectionBeliefs__standfirst",
  title: "SectionBeliefs__title",
};
